import WriteOff from '@/api/stock/write-off'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  products: [],
  uom: [],
  stockInNumbers: [],
  categoryAvailable: [],
  productAvailable: [],
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {
  getUomNameById: state => uomId => {
    return state.uom.find(u => u.uom_id == uomId).uom_name_en
  },
  getProdcutById: state => productId => {
    return state.products.find(p => p.product_id == productId)
  },
  totalAmount: (state, getters) => detail => {
    try {
      let amount = detail.cost * detail.quantity
      return _.ceil(amount, 2)
    } catch (e) {
      return 0
    }
  },
  isDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures)
        .flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) => (init = value))
    }
    return null
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_UOM(state, data) {
    state.uom = data
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_STOCK_IN_NUMBERS(state, data) {
    state.stockInNumbers = data
  },
  SET_CATEGORY_AVAILABLE(state, data) {
    state.categoryAvailable = data
  },
  SET_PRODUCT_AVAILABLE(state, data) {
    state.productAvailable = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return WriteOff.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return WriteOff.store(data)
  },

  update(context, data) {
    return WriteOff.update(data)
  },
  destroy(context, id) {
    return WriteOff.destroy(id)
  },

  confirm(context, data) {
    return WriteOff.updateStatus(data)
  },

  reject(context, data) {
    return WriteOff.updateStatus(data)
  },

  getProductSearch(context, attribute = {}) {
    return WriteOff.productSearch({ params: attribute })
  },
  getProductAvailableSearch(context, attribute = {}) {
    return WriteOff.productAvailableSearch({ params: attribute })
  },
  async getCategoryAvailable(context, attribute = {}) {
    let response = await WriteOff.getCategoryAvailable({ params: attribute })
    context.commit('SET_CATEGORY_AVAILABLE', response)
  },
  async getProductAvailable(context, attribute = {}) {
    let response = await WriteOff.getProductAvailable({ params: attribute })
    context.commit('SET_PRODUCT_AVAILABLE', response)
  },
  availableQuantity(context, productId) {
    return WriteOff.sysQty(productId)
  },
  getNewSerialByQty(context, attribute = {}) {
    return WriteOff.getNewSerialByQty({ params: attribute })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await WriteOff.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.products.length > 0) {
      let response = await WriteOff.product()
      context.commit('SET_PRODUCT', response.data)
    }
    if (!context.state.uom.length > 0) {
      let response = await WriteOff.uom()
      context.commit('SET_UOM', response.data)
    }
    if (!context.state.stockInNumbers.length > 0) {
      let response = await WriteOff.getStockInNumber()
      context.commit('SET_STOCK_IN_NUMBERS', response.data)
    }
    return Promise.resolve()
  }
}
